import initialState from './initial-state'
import * as ACTIONS from 'constant/actions/user-management'

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.USER_MANAGEMENT_SHOW_MODAL:
      state = {
        ...state,
        modalShowing: true,
        modalContent: action.modalContent
      }
      break
    case ACTIONS.USER_MANAGEMENT_HIDE_MODAL:
      state = {
        ...state,
        modalContent: undefined,
        modalShowing: false
      }
      break
    case ACTIONS.USER_MANAGEMENT_GET_ALL_USERS + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          usersList: action.payload.data.userList
        }
      }
      break
    case ACTIONS.USER_MANAGEMENT_GET_USER_ROLES + '_FULFILLED':
      if (action.payload.data.success) {
        state = {
          ...state,
          userRoles: action.payload.data.roleList
        }
      }
  }
  return state
}
